export const messages = {
  en: {
    carCreateFee: {
      customTemplate: 'Custom Template',
      customImport: 'Custom Import',
      enterCarNum: 'Enter license plate number',
      selectParkingArea: 'Select parking area',
      enterParkingSpace: 'Enter parking space',
      enterOwnerName: 'Enter owner name',
      selectParkingSpaceStatus: 'Select parking space status',
      search: 'Search',
      vehicleFee: 'Vehicle Fee',
      paymentHistory: 'Payment History',
      prepayment: 'Prepayment',
      setFee: 'Set Fee',
      house: 'House',
      owner: 'Owner',
      reprintReceipt: 'Reprint Receipt'
    },
    carCreateFeeAdd: {
      createFee: 'Create Fee',
      car: 'Car',
      enterCar: 'Enter car',
      feeType: 'Fee Type',
      selectFeeType: 'Select fee type',
      feeItem: 'Fee Item',
      selectFeeItem: 'Select fee item',
      feeAmount: 'Fee Amount',
      enterFeeAmount: 'Enter fee amount',
      billingStartTime: 'Billing Start Time',
      enterBillingStartTime: 'Enter billing start time',
      billingEndTime: 'Billing End Time',
      enterBillingEndTime: 'Enter billing end time',
      feeTypeRequired: 'Fee type is required',
      feeItemRequired: 'Fee item is required',
      billingTypeRequired: 'Billing type is required',
      billingStartTimeRequired: 'Billing start time is required',
      amountRequired: 'Amount is required',
      amountFormatError: 'Amount format error',
      dateFormatError: 'Date format error',
      endTimeAfterStart: 'End time must be after start time',
      createSuccess: 'Create successful',
      createFailed: 'Create failed'
    },
    exportCarFeeImportExcel: {
      templateExport: "Template Export",
      parkingLot: "Parking Lot",
      all: "All",
      parkingLotPlaceholder: "Parking Lot",
      feeItem: "Fee Item",
      export: "Export",
      cancel: "Cancel"
    },
    doImportCreateFee: {
      customCreateFee: "Custom Create Fee",
      selectFile: "Select File",
      requiredFile: "Required, please select data file",
      import: "Import",
      cancel: "Cancel"
    },
    parkingAreaSelect2: {
      parkingLotPlaceholder: "Required, please select parking lot"
    },
    feeDetailCarFeeRule: {
      createFee: 'Create Fee',
      tempFee: 'Temporary Fee',
      ruleId: 'Rule ID',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      createTime: 'Create Time',
      validity: 'Validity',
      formula: 'Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional/Fixed Fee',
      status: 'Status',
      valid: 'Valid',
      invalid: 'Invalid',
      billDate: 'Bill Date',
      billCycle: 'Bill Cycle',
      monthly: 'Monthly',
      operation: 'Operation',
      change: 'Change',
      manualFinish: 'Manual Finish',
      cancel: 'Cancel'
    },
  },
  zh: {
    carCreateFee: {
      customTemplate: '自定义模板',
      customImport: '自定义导入',
      enterCarNum: '请填写车牌号',
      selectParkingArea: '请选择停车场',
      enterParkingSpace: '请填写车位',
      enterOwnerName: '请填写业主名称',
      selectParkingSpaceStatus: '请选择车位状态',
      search: '查询',
      vehicleFee: '车辆费用',
      paymentHistory: '缴费历史',
      prepayment: '预付收款',
      setFee: '设置费用',
      house: '房屋',
      owner: '业主',
      reprintReceipt: '补打收据'
    },
    carCreateFeeAdd: {
      createFee: '创建费用',
      car: '车辆',
      enterCar: '必填，请填写车辆',
      feeType: '费用类型',
      selectFeeType: '必填，请选择费用类型',
      feeItem: '收费项目',
      selectFeeItem: '必填，请选择收费项目',
      feeAmount: '收费金额',
      enterFeeAmount: '必填，请填写收费金额',
      billingStartTime: '计费起始时间',
      enterBillingStartTime: '必填，请填写计费起始时间',
      billingEndTime: '计费结束时间',
      enterBillingEndTime: '必填，请填写计费结束时间',
      feeTypeRequired: '费用类型不能为空',
      feeItemRequired: '费用项目不能为空',
      billingTypeRequired: '出账类型不能为空',
      billingStartTimeRequired: '计费起始时间不能为空',
      amountRequired: '金额不能为空',
      amountFormatError: '金额格式错误',
      dateFormatError: '时间格式错误 YYYY-MM-DD hh:mm:ss',
      endTimeAfterStart: '结束时间必须大于开始时间',
      createSuccess: '创建收费成功',
      createFailed: '创建收费失败'
    },
    exportCarFeeImportExcel: {
      templateExport: "模板导出",
      parkingLot: "停车场",
      all: "全部",
      parkingLotPlaceholder: "停车场",
      feeItem: "费用项",
      export: "导出",
      cancel: "取消"
    },
    doImportCreateFee: {
      customCreateFee: "自定义创建费用",
      selectFile: "选择文件",
      requiredFile: "必填，请选择数据文件",
      import: "导入",
      cancel: "取消"
    },
    parkingAreaSelect2: {
      parkingLotPlaceholder: "必填，请选择停车场"
    },
    feeDetailCarFeeRule: {
      createFee: '创建费用',
      tempFee: '临时收费',
      ruleId: '规则编号',
      feeItem: '费用项',
      feeFlag: '费用标识',
      createTime: '建账时间',
      validity: '账单有效期',
      formula: '账单公式',
      unitPrice: '计费单价',
      additionalFee: '附加/固定费用',
      status: '状态',
      valid: '有效',
      invalid: '失效',
      billDate: '账单日',
      billCycle: '账单周期',
      monthly: '按月',
      operation: '操作',
      change: '变更',
manualFinish: '手工结束',
      cancel: '取消'
    },
  },
  'zh-TW': {
    carCreateFee: {
      customTemplate: '自訂義模板',
      customImport: '自訂義導入',
      enterCarNum: '請填寫車牌號',
      selectParkingArea: '請選擇停車場',
      enterParkingSpace: '請填寫車位',
      enterOwnerName: '請填寫業主名稱',
      selectParkingSpaceStatus: '請選擇車位狀態',
      search: '查詢',
      vehicleFee: '車輛費用',
      paymentHistory: '繳費歷史',
      prepayment: '預付收款',
      setFee: '設置費用',
      house: '房屋',
      owner: '業主',
      reprintReceipt: '補打收據'
    },
    carCreateFeeAdd: {
      createFee: '創建費用',
      car: '車輛',
      enterCar: '必填，請填寫車輛',
      feeType: '費用類型',
      selectFeeType: '必填，請選擇費用類型',
      feeItem: '收費項目',
      selectFeeItem: '必填，請選擇收費項目',
      feeAmount: '收費金額',
      enterFeeAmount: '必填，請填寫收費金額',
      billingStartTime: '計費起始時間',
      enterBillingStartTime: '必填，請填寫計費起始時間',
      billingEndTime: '計費結束時間',
      enterBillingEndTime: '必填，請填寫計費結束時間',
      feeTypeRequired: '費用類型不能為空',
      feeItemRequired: '費用項目不能為空',
      billingTypeRequired: '出帳類型不能為空',
      billingStartTimeRequired: '計費起始時間不能為空',
      amountRequired: '金額不能為空',
      amountFormatError: '金額格式錯誤',
      dateFormatError: '時間格式錯誤 YYYY-MM-DD hh:mm:ss',
      endTimeAfterStart: '結束時間必須大於開始時間',
      createSuccess: '創建收費成功',
      createFailed: '創建收費失敗'
    },
    exportCarFeeImportExcel: {
      templateExport: "模板導出",
      parkingLot: "停車場",
      all: "全部",
      parkingLotPlaceholder: "停車場",
      feeItem: "費用項",
      export: "導出",
      cancel: "取消"
    },
    doImportCreateFee: {
      customCreateFee: "自訂義創建費用",
      selectFile: "選擇文件",
      requiredFile: "必填，請選擇數據文件",
      import: "導入",
      cancel: "取消"
    },
    parkingAreaSelect2: {
      parkingLotPlaceholder: "必填，請選擇停車場"
    },
    feeDetailCarFeeRule: {
      createFee: '創建費用',
      tempFee: '臨時收費',
      ruleId: '規則編號',
      feeItem: '費用項',
      feeFlag: '費用標識',
      createTime: '建帳時間',
      validity: '帳單有效期',
      formula: '帳單公式',
      unitPrice: '計費單價',
      additionalFee: '附加/固定費用',
      status: '狀態',
      valid: '有效',
      invalid: '失效',
      billDate: '帳單日',
      billCycle: '帳單週期',
      monthly: '按月',
      operation: '操作',
      change: '變更',
      manualFinish: '手工結束',
      cancel: '取消'
    },
  }
}